import React from 'react'
import './Stats.scss'

export default function Stats({ event_scoreboard, scoreboard }) {

    function getValueFromScoreboard(name) {
        if (!scoreboard) {
            return null
        }

        const found = scoreboard.find(i => i.name === name)

        if (found){
            return found.value
        }

        return null
    }

    const TeamA = getValueFromScoreboard('TeamA')
    const TeamB = getValueFromScoreboard('TeamB')

    const TeamAAllOuts = getValueFromScoreboard('Team A All Outs')
    const TeamBAllOuts = getValueFromScoreboard('Team B All Outs')
    const TotalAllOuts = getValueFromScoreboard('Total All Outs')

    const TeamAEmptyRaids = getValueFromScoreboard('Team A Empty Raids')
    const TeamBEmptyRaids = getValueFromScoreboard('Team B Empty Raids')
    const TotalEmptyRaids = getValueFromScoreboard('Total Empty Raids')

    const TeamASuperRaids = getValueFromScoreboard('Team A Super Raids')
    const TeamBSuperRaids = getValueFromScoreboard('Team B Super Raids')
    const TotalSuperRaids = getValueFromScoreboard('Total Super Raids')

    const TeamABonusPoints = getValueFromScoreboard('Team A Bonus Points')
    const TeamBBonusPoints = getValueFromScoreboard('Team B Bonus Points')
    const TotalBonusPoints = getValueFromScoreboard('Total Bonus Points')

    const TeamASuperTackles = getValueFromScoreboard('Team A Super Tackles')
    const TeamBSuperTackles = getValueFromScoreboard('Team B Super Tackles')
    const TotalSuperTackles = getValueFromScoreboard('Total Super Tackles')

    const TeamASuccessfulRaids = getValueFromScoreboard('Team A Successful Raids')
    const TeamBSuccessfulRaids = getValueFromScoreboard('Team B Successful Raids')
    const TotalSuccessfulRaids = getValueFromScoreboard('Total Successful Raids')

    const TeamAUnsuccessfulRaids = getValueFromScoreboard('Team A Unsuccessful Raids')
    const TeamBUnsuccessfulRaids = getValueFromScoreboard('Team B Unsuccessful Raids')
    const TotalUnsuccessfulRaids = getValueFromScoreboard('Total Unsuccessful Raids')

    return (
        <div className="stats">
            <div className="stats-table">
                <div className="stats-table-header">
                    <div></div>
                    <div>{TeamA}</div>
                    <div>{TeamB}</div>
                    <div>Total</div>
                </div>
                <div className="stats-table-row">
                    <div style={{ fontWeight: 'bold' }}>Successful Raids</div>
                    <div>{TeamASuccessfulRaids}</div>
                    <div>{TeamBSuccessfulRaids}</div>
                    <div>{TotalSuccessfulRaids}</div>
                </div>
                <div className="stats-table-row">
                    <div style={{ fontWeight: 'bold' }}>Unsuccessful Raids</div>
                    <div>{TeamAUnsuccessfulRaids}</div>
                    <div>{TeamBUnsuccessfulRaids}</div>
                    <div>{TotalUnsuccessfulRaids}</div>
                </div>
                <div className="stats-table-row">
                    <div style={{ fontWeight: 'bold' }}>Empty Raids</div>
                    <div>{TeamAEmptyRaids}</div>
                    <div>{TeamBEmptyRaids}</div>
                    <div>{TotalEmptyRaids}</div>
                </div>
                <div className="stats-table-row">
                    <div style={{ fontWeight: 'bold' }}>Bonus Points</div>
                    <div>{TeamABonusPoints}</div>
                    <div>{TeamBBonusPoints}</div>
                    <div>{TotalBonusPoints}</div>
                </div>
                <div className="stats-table-row">
                    <div style={{ fontWeight: 'bold' }}>Super Tackles</div>
                    <div>{TeamASuperTackles}</div>
                    <div>{TeamBSuperTackles}</div>
                    <div>{TotalSuperTackles}</div>
                </div>
                <div className="stats-table-row">
                    <div style={{ fontWeight: 'bold' }}>Super Raids</div>
                    <div>{TeamASuperRaids}</div>
                    <div>{TeamBSuperRaids}</div>
                    <div>{TotalSuperRaids}</div>
                </div>
                <div className="stats-table-row">
                    <div style={{ fontWeight: 'bold' }}>All Outs</div>
                    <div>{TeamAAllOuts}</div>
                    <div>{TeamBAllOuts}</div>
                    <div>{TotalAllOuts}</div>
                </div>
            </div>
        </div>
    )
}
